// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import axios from 'axios'
import http from './api/http'
import VueCookie from 'vue-cookies'
import weui from 'weui.js'
import 'weui'
import 'element-ui/lib/theme-chalk/index.css'
import ElementUI from 'element-ui'

Vue.config.productionTip = false
Vue.use(VueCookie)
Vue.use(ElementUI)
Vue.prototype.$axios = axios
Vue.prototype.http = http
Vue.prototype.$weui = weui
/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js